<form [formGroup]="form">
  <!--- Oprettelsesdetaljer --->
  <app-guide-card [fullWidth]="fullWidth" [valid]="form.get('validFrom')?.valid">
    <div title>
      {{ 'meteringPoint.create.creationDetails.title' | translate }}
    </div>
    <div description>
      {{ 'meteringPoint.create.creationDetails.description' | translate }}
    </div>
    <div>
      <app-input-group [hideDisabled]="true">
        <label appLabel>{{ 'meteringPoint.create.validFrom' | translate }}</label>
        <input appInputDate type="date" formControlName="validFrom">
      </app-input-group>
    </div>
  </app-guide-card>
</form>
